var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"l-content"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-16 col-xs-offset-1 col-sm-14 col-sm-offset-2"},[_c('div',{staticClass:"se-statement mb",style:(_vm.bgc)},[_c('div',{staticClass:"se-statement__text-container"},[_vm._t("default")],2)])])])])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-865c4018","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Statement.vue
// module id = null
// module chunks = 